<template>
  <div class="scheme">
    <div class="schemeHeader">
      <div v-for="(item, index) in industryList" :key="index" class="every">
        <div class="cardText">
          <div class="cardTitle">{{ item.title }}</div>
          <div class="cardDesc">{{ item.desc }}</div>
        </div>
        <img :src="item.icon" alt="" class="cardIcon" />
      </div>
    </div>
    <div class="case">
      <div class="headline">企业信息</div>
      <div class="caseFlex">
        <img src="@/assets/Sliceu6.png" alt="" />
        <div>
          <div class="tilte">2024年岳阳湘阴县三塘镇“三无”船舶改装闪爆事故</div>
          <div>
            2024年3月8日14时8分许，岳阳市湘阴县三塘镇蒙古包村一组湘江靠岸滩头水域，一艘靠岸停泊的“三无”船舶在改装作业过程中发生爆炸，造成4人死亡、船舶损毁，直接经济损失333.4万元。
          </div>
          <div class="m32">
            调查认定，岳阳湘阴“3·8”船舶改装闪爆事故是一起因“三无”船舶所有人雇用无资质人员违规改装，作业过程中违规动火焊接引爆船舶工棚内聚集的可燃气体导致的较大生产安全责任事故。.4万元。
          </div>
        </div>
      </div>
    </div>
    <div
      style="
        min-height: 1080px;
        box-sizing: border-box;
        padding: 108px 240px 120px;
        background: url('~@/assets/industry-solution-banner-bg.png') center top /
          1920px 1080px no-repeat;
      "
    >
      <div class="headline">解决方案</div>
      <div
        style="
          display: grid;
          grid-template-columns: repeat(6, 1fr);
          row-gap: 150px;
          align-items: start;
          margin-top: 40px;
          text-align: center;
        "
      >
        <div
          style="grid-column: 2 / span 2; justify-self: center; width: 371px"
        >
          <img
            :src="require('@/assets/industry-solution-advantage-02.png')"
            alt=""
            style="width: 180px; height: 200px; object-fit: contain"
          />
          <div
            style="
              margin-top: 40px;
              font-size: 16px;
              line-height: 28px;
              color: #141414;
            "
          >
            平台通过实名认证和活体人脸识别等审核，确保所有注册的特种作业人员都持有合规的证书，从源头杜绝无证上岗的现象。
          </div>
        </div>
        <div
          style="grid-column: 4 / span 2; justify-self: center; width: 371px"
        >
          <img
            :src="require('@/assets/industry-solution-advantage-03.png')"
            alt=""
            style="width: 180px; height: 200px; object-fit: contain"
          />
          <div
            style="
              margin-top: 40px;
              font-size: 16px;
              line-height: 28px;
              color: #141414;
            "
          >
            利用大数据和AI智能技术，对供需双方的数据进行精细匹配实现优先派单，减少空单和无效匹配。
          </div>
        </div>
        <div
          style="grid-column: 1 / span 2; justify-self: center; width: 371px"
        >
          <img
            :src="require('@/assets/industry-solution-advantage-04.png')"
            alt=""
            style="width: 180px; height: 200px; object-fit: contain"
          />
          <div
            style="
              margin-top: 40px;
              font-size: 16px;
              line-height: 28px;
              color: #141414;
            "
          >
            平台建立工作记录系统，记录每次作业的详细信息，包括人员、时间、地点、内容等便于追溯和查询。
          </div>
        </div>
        <div
          style="grid-column: 3 / span 2; justify-self: center; width: 371px"
        >
          <img
            :src="require('@/assets/industry-solution-advantage-05.png')"
            alt=""
            style="width: 180px; height: 200px; object-fit: contain"
          />
          <div
            style="
              margin-top: 40px;
              font-size: 16px;
              line-height: 28px;
              color: #141414;
            "
          >
            平台提供标准化的合同模板，明确双方的权力和义务，规范作业流程，引入保险公司提供实时保障，提供在线支付和自动结算功能。
          </div>
        </div>
        <div
          style="grid-column: 5 / span 2; justify-self: center; width: 371px"
        >
          <img
            :src="require('@/assets/industry-solution-advantage-01.png')"
            alt=""
            style="width: 180px; height: 200px; object-fit: contain"
          />
          <div
            style="
              margin-top: 40px;
              font-size: 16px;
              line-height: 28px;
              color: #141414;
            "
          >
            监管部门通过平台实时掌握任务数据、人员信息和服务评价，建立了特种作业人员信用评分体系，打通税务最后一公里，实现合同流、信息流、资金流、发票流，四流合一的目标。
          </div>
        </div>
      </div>
    </div>
    <div class="schemeTable">
      <tableScheme class="tableScheme" />
    </div>
    <div class="scene">
      <div class="headline">适用场景</div>
      <div class="sceneMain">
        <div v-for="(item, index) in sceneList" :key="index" class="sceneEvery">
          <img :src="item.url" alt="" />
          <div>
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tableScheme from "./tableScheme.vue";
export default {
  components: { tableScheme },
  data() {
    return {
      industryList: [
        {
          title: "用工合规性问题",
          desc: "劳动法、税务和社保规定，企业可能因不合规操作面临法律风险。",
          icon: require("@/assets/industry-solution-service-card-01.png"),
        },
        {
          title: "人员流动",
          desc: "灵活用工人员的技能水平和工作态度参差不齐，可能影响工作质量和效率。",
          icon: require("@/assets/industry-solution-service-card-02.png"),
        },
        {
          title: "管理复杂度高",
          desc: "人员流动性大，管理难度较高，需要处理大量的合同、薪酬、考勤等事务，增加了管理负担。",
          icon: require("@/assets/industry-solution-service-card-03.png"),
        },
        {
          title: "数据安全与隐私保护",
          desc: "灵活用工涉及大量个人信息和用工数据，存在数据泄露和隐私保护的风险。",
          icon: require("@/assets/industry-solution-service-card-04.png"),
        },
        {
          title: "用工成本控制",
          desc: "灵活用工可以降低固定成本，但招聘、培训和管理费及用工人员的整体成本较高。",
          icon: require("@/assets/industry-solution-service-card-05.png"),
        },
        {
          title: "员工归属感与忠诚度低",
          desc: "灵活用工人员缺乏归属感，可能导致工作积极性不高。",
          icon: require("@/assets/industry-solution-service-card-06.png"),
        },
      ],
      sceneList: [
        {
          url: require("@/assets/Config.png"),
          name: "生产制造行业",
        },
        {
          url: require("@/assets/Building-one.png"),
          name: "建筑工程行业",
        },
        {
          url: require("@/assets/Medical-box.png"),
          name: "医药医疗行业",
        },
        {
          url: require("@/assets/Bowl.png"),
          name: "餐饮服务行业",
        },
        {
          url: require("@/assets/Cruise.png"),
          name: "商贸流通行业",
        },
        {
          url: require("@/assets/Buy.png"),
          name: "社交电商行业",
        },
        {
          url: require("@/assets/Car.png"),
          name: "共享出行行业",
        },
        {
          url: require("@/assets/Internal-transmission.png"),
          name: "配送服务行业",
        },
        {
          url: require("@/assets/Local-pin.png"),
          name: "生活服务行业",
        },
        {
          url: require("@/assets/Camera-one.png"),
          name: "网红直播行业",
        },
        {
          url: require("@/assets/Layers.png"),
          name: "营销推广行业",
        },
        {
          url: require("@/assets/Slide.png"),
          name: "销售服务行业",
        },
        {
          url: require("@/assets/Table-report.png"),
          name: "广告传媒行业",
        },
        {
          url: require("@/assets/Terminal.png"),
          name: "高新技术行业",
        },
        {
          url: require("@/assets/Cpu.png"),
          name: "软件硬件行业",
        },
        {
          url: require("@/assets/Bookmark.png"),
          name: "教育培训行业",
        },
        {
          url: require("@/assets/Airplay_(AirPlay).png"),
          name: "互联网科技行业",
        },
        {
          url: require("@/assets/Entertainment.png"),
          name: "文化娱乐行业",
        },
        {
          url: require("@/assets/Graphic-design.png"),
          name: "设计咨询行业",
        },
        {
          url: require("@/assets/Camera.png"),
          name: "自媒体行业",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    toDetail(item) {
      this.productCode = item.code;
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.scheme {
  background: #ffffff;
  // padding: 0 240px;
}
.schemeTop {
  display: flex;
  justify-content: center;
  margin-top: 25px;
  .schemeEvery {
    font-weight: 500;
    font-size: 18px;
    color: #606060;
    line-height: 26px;
    margin-right: 148px;
    position: relative;
  }
}

.active {
  font-weight: 500 !important;
  font-size: 24px !important;
  color: #141414 !important;
}
.active::after {
  content: "";
  position: absolute;
  bottom: -8px;
  left: 25%;
  width: 50%;
  border-radius: 50px;
  height: 3px;
  background-color: #1c87ff;
}
.schemeHeader {
  display: grid;
  grid-template-columns: repeat(3, 440px);
  justify-content: center;
  gap: 80px 64px;
  min-height: 864px;
  box-sizing: border-box;
  padding: 120px 0 128px;
  background-image: url("~@/assets/industry-solution-banner-bg.png");
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 1920px 1080px;
  .every {
    width: 440px;
    height: 268px;
    position: relative;
    box-sizing: border-box;
    padding: 60px 44px;
    overflow: hidden;
    text-align: left;
    background: #f5f7fb;
    box-shadow: 24px 39px 101px 0px rgba(0, 34, 51, 0),
      97px 155px 183px 0px rgba(0, 34, 51, 0),
      218px 349px 247px 0px rgba(0, 34, 51, 0),
      387px 621px 250px 0px rgba(0, 34, 51, 0),
      605px 970px 250px 0px rgba(0, 34, 51, 0);
    border-radius: 16px;
  }
  .cardText {
    position: relative;
    z-index: 2;
    width: 260px;
  }
  .cardTitle {
    font-weight: 600;
    font-size: 24px;
    color: #141414;
    line-height: 32px;
    margin-bottom: 28px;
  }
  .cardDesc {
    font-weight: 400;
    font-size: 16px;
    color: #141414;
    line-height: 28px;
  }
  .cardIcon {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 168px;
    height: 128px;
    object-fit: contain;
    user-select: none;
  }
}
@media (max-width: 750px) {
  .schemeHeader {
    grid-template-columns: 1fr;
    gap: 32px;
    padding: 52px 32px;
    .every {
      width: 100%;
      height: 268px;
      padding: 42px 36px;
    }
    .cardText {
      width: 360px;
    }
    .cardTitle {
      font-size: 28px;
      line-height: 36px;
      margin-bottom: 24px;
    }
    .cardDesc {
      font-size: 22px;
      line-height: 34px;
    }
    .cardIcon {
      width: 168px;
      height: 128px;
    }
  }
}
.headline {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 28px;
  color: #141414;
  line-height: 36px;
}
.case {
  padding: 100px 240px;

  .caseFlex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 100px;
    text-align: left;
    font-weight: 400;
    font-size: 16px;
    color: #141414;
    line-height: 32px;
    img {
      width: 740px;
      height: 440px;
      margin-right: 124px;
    }
    .tilte {
      font-family: PingFang SC, PingFang SC;
      font-weight: 800;
      line-height: 52px;
      font-size: 32px;
      color: #333333;
      margin-bottom: 100px;
    }
    .m32 {
      margin-top: 32px;
    }
  }
}
.schemeTable {
  width: 100%;
  height: 324px;
  background: #f5f6fa;
  color: #141414;
  position: relative;
  .tableScheme {
    position: absolute;
    bottom: -200px;
    left: 330px;
  }

  @media (max-width: 750px) {
    .tableScheme {
      left: 50px;
      right: 50px;
    }
  }
}
.scene {
  padding: 334px 240px 218px 240px;
  .sceneMain {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    margin-top: 87px;
    img {
      width: 36px;
      height: 36px;
      margin-right: 10px;
    }
    .sceneEvery {
      width: 20%;
      font-weight: 400;
      font-size: 24px;
      color: #000000;
      line-height: 26px;
      margin-bottom: 116px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

@media (max-width: 750px) {
  .case {
    padding: 150px 100px;
  }
  .Sliceu7 {
    width: 100%;
    height: 1080px;
  }
  .scene {
    padding: 334px 120px 218px 120px;
  }
}
</style>
